module.exports = __webpack_public_path__ + "img/koivu-logo.c7bef3c9.svg";